import React, { useState, useEffect, useRef, useContext } from 'react';
import authentication from '../../B2CAuth';
import logComponent from '../../common/logComponent';
//import { useMsal, useIsAuthenticated  } from "@azure/msal-react";
import Loading from '../Loading/Loading';

export default function Logout() {
  //const { instance } = useMsal();
  //const { isAuthenticated } = useIsAuthenticated();
  if (logComponent('Logout')) { console.debug('Logout rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    authentication.signOut();
  //  if(isAuthenticated)
  //    instance.logout();
  }, []);

    return (
      <Loading />
    );
}
